export default __webpack_public_path__ + "static/media/main-logo.65567109.svg";